import { render } from "./complianceReview.vue?vue&type=template&id=ab5660b4&scoped=true&ts=true"
import script from "./complianceReview.vue?vue&type=script&lang=ts"
export * from "./complianceReview.vue?vue&type=script&lang=ts"

import "./complianceReview.vue?vue&type=style&index=0&id=ab5660b4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ab5660b4"]])

export default __exports__